// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SecretChatRequestPopup__popup-fdc438 {
  width: 100%;
  height: fit-content;
  flex: none;
  max-width: 440px;
  min-height: 424px;
}

.SecretChatRequestPopup__wrapper-dc4f0d {
  overflow-y: auto;
  height: fit-content;
  width: 100%;
  background: var(--gradient-10);
  background-size: 100% 258px;
  background-repeat: no-repeat;
  padding: 24px;
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.SecretChatRequestPopup__logo-dc9891 {
  width: 120px;
  height: 120px;
}

.SecretChatRequestPopup__title-bf18dc {
  color: transparent;
  -webkit-background-clip: text;
  background-clip: text;
  background-image: var(--gradient-0);
  font: var(--font-title-6);
  margin-top: 24px;
  letter-spacing: var(--font-spacing-title-6);
  margin-bottom: 16px;
  text-align: center;
}

.SecretChatRequestPopup__description-e36770 {
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  color: var(--base-120);
  text-align: center;
  margin-bottom: 32px;
}

.SecretChatRequestPopup__close-a05c1f {
  display: var(--display-actions);
  position: absolute;
  inset-inline-end: 24px;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/SecretChatRequestPopup/SecretChatRequestPopup.styles.m.css"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,mBAAA;EACA,UAAA;EACA,gBAAA;EACA,iBAAA;AACF;;AAEA;EACE,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,8BAAA;EACA,2BAAA;EACA,4BAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AACF;;AAEA;EACE,YAAA;EACA,aAAA;AACF;;AAEA;EACE,kBAAA;EACA,6BAAA;EACA,qBAAA;EACA,mCAAA;EACA,yBAAA;EACA,gBAAA;EACA,2CAAA;EACA,mBAAA;EACA,kBAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;AACF;;AAEA;EACE,+BAAA;EACA,kBAAA;EACA,sBAAA;AACF","sourcesContent":[".popup {\n  width: 100%;\n  height: fit-content;\n  flex: none;\n  max-width: 440px;\n  min-height: 424px;\n}\n\n.wrapper {\n  overflow-y: auto;\n  height: fit-content;\n  width: 100%;\n  background: var(--gradient-10);\n  background-size: 100% 258px;\n  background-repeat: no-repeat;\n  padding: 24px;\n  position: relative;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.logo {\n  width: 120px;\n  height: 120px;\n}\n\n.title {\n  color: transparent;\n  -webkit-background-clip: text;\n  background-clip: text;\n  background-image: var(--gradient-0);\n  font: var(--font-title-6);\n  margin-top: 24px;\n  letter-spacing: var(--font-spacing-title-6);\n  margin-bottom: 16px;\n  text-align: center;\n}\n\n.description {\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  color: var(--base-120);\n  text-align: center;\n  margin-bottom: 32px;\n}\n\n.close {\n  display: var(--display-actions);\n  position: absolute;\n  inset-inline-end: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popup": `SecretChatRequestPopup__popup-fdc438`,
	"wrapper": `SecretChatRequestPopup__wrapper-dc4f0d`,
	"logo": `SecretChatRequestPopup__logo-dc9891`,
	"title": `SecretChatRequestPopup__title-bf18dc`,
	"description": `SecretChatRequestPopup__description-e36770`,
	"close": `SecretChatRequestPopup__close-a05c1f`
};
module.exports = ___CSS_LOADER_EXPORT___;
